import React from 'react';
import Cookies from 'js-cookie';
import _ from 'lodash';
import Sorting from './Sorting';
// import SearchBar from 'material-ui-search-bar'
import '../css/Misc.css';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import Loader from './Loader';
;


// component used in ai section for viewing ai data
class Misc extends React.Component{
  state={
    logData: [],
    sortedType: '',
    searchValue: '', 
    actualData: [],
    loadSpinner: true,
    sortingStatus: {
      sortingName: '',
      defaultDown: true
    },
  }


  componentDidMount(){
    this.dataList()
      }

      
  restoreData = (data) => {
    this.setState({
      logData: data
    })
 }


 openModal() {
  this.setState({
    modalIsOpenAddChannel: false
  }, () => {
    this.setState({
      modalIsOpenAddChannel: true
    })
  })
}

closeModal() {
  this.setState({ modalIsOpenAddChannel: false });
}

 dataList = () =>{
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  fetch('/cloud/d2hshowstabledata' ,{
          method: "GET",
          headers: headers,
      })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => {
        console.log(data.length)
        this.setState({
          logData: data,
          actualData: data
        },()=>{
          this.setState({
            loadSpinner: false
          })
        })
      })
      .catch((err)=>{
        console.log(err)
      })
 }

 sortingFunc = (type, searchValue) => {
  if (type !== 'search') {
    if (this.state.sortingStatus.sortingName === type) {
      this.setState({
        sortingStatus: {
          sortingName: type,
          defaultDown: !this.state.sortingStatus.defaultDown
        },
      }, () => {
        if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
          Sorting(this.restoreData, type, this.state.logData.sort());
          // Sorting(this.restoreData, type, this.state.actualData);
        } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
          Sorting(this.restoreData, 'reverse', this.state.logData.sort());
        }
      })
    } else {
      this.setState({
        sortingStatus: {
          sortingName: type,
          defaultDown: true
        },
      }, () => {
        if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
          Sorting(this.restoreData, type, this.state.logData.sort());
          // Sorting(this.restoreData, type, this.state.actualData);
        } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
          Sorting(this.restoreData, 'reverse', this.state.logData.sort());
        }
      })
    }
  } else if (type === 'search') {
    type = 'search';
    Sorting(this.restoreData, type, this.state.actualData, searchValue);
  } else {
    type = 'reverse';
    Sorting(this.restoreData, type, this.state.actualData);
  }
}

fetchIconType = (e) => {
  if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
    return 'fas fa-chevron-down pointer ml-2 float-right'
  } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
    return 'fas fa-chevron-up pointer ml-2 float-right'
  } else {
    return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
  }
}

obDatatable = () => { 
  return this.state.logData.map((e, index) => {
    return (
      <React.Fragment>
        <tr key={index} className="some-hover">
          <td scope="col" style={{ width: '10%',minWidth: '150px', verticalAlign: 'middle', }}>{index+1}</td>
          <td scope="col" style={{ width: '20%', verticalAlign: 'middle', }}>{e.channel_name}</td>
          <td scope="col" style={{ width: '15%', verticalAlign: 'middle', }}>{e.genre}</td>
          <td scope="col" style={{ width: '15%', verticalAlign: 'middle', }}>{e.shows}</td>
          <td scope="col" style={{ width: '15%', verticalAlign: 'middle', }}>{e.date} / {e.duration} min</td>
        </tr>
      </React.Fragment>
    )
  })   
}




    render(){
        return (
          <React.Fragment>
          {this.state.loadSpinner ? <Loader /> : null}
         <div style={{ paddingLeft: '90px', paddingTop: '40px', paddingRight: '90px', height: `${window.innerHeight - 120}px` }}>
           {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
             <span style={{ color: '#888888', fontSize: '30px', }}>D2H Shows User Data</span>            
           </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
               <IntegrationReactSelectNew autoFocus
                 value={this.state.searchValue}
                 onChange={(e) => {
                   this.setState({
                     searchValue: e
                   }, () => {
                     this.sortingFunc('search', this.state.searchValue)
                   })
                 }
                 }
                 onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
                 resetSearch={(e) => {
                   this.setState({
                     searchValue: e
                   }, () => {
                     this.sortingFunc('search', '')
                   })
                 }}
               /></div>}
           <div className="si-lisst col-s12">
             {this.state.addAnotherSuccess}
             <table className="table">
               <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
                 <th scope="col" style={{ width: '10%', minWidth: '150px', verticalAlign: 'middle' }}>S.No.
           <i class={this.fetchIconType('channel_Number')} onClick={(e) => { this.sortingFunc('channel_Number') }}></i>
                 </th>
                 <th scope="col" style={{ width: '20%', verticalAlign: 'middle' }}>Channel
           <i class={this.fetchIconType('channel_name')} onClick={(e) => { this.sortingFunc('channel_name') }}></i>
                 </th>
                 <th scope="col" style={{ width: '15%', verticalAlign: 'middle' }}>Genre
           <i class={this.fetchIconType('genre')} onClick={(e) => { this.sortingFunc('genre') }}></i>
                 </th>
                 <th scope="col" style={{ width: '15%', verticalAlign: 'middle' }}>Shows
           <i class={this.fetchIconType('shows')} onClick={(e) => { this.sortingFunc('shows') }}></i>
                 </th>
                 <th scope="col" style={{ width: '15%', verticalAlign: 'middle' }}>Date / Duration</th>     
               </thead>
               <tbody style={{ overflowY: 'overlay' ,maxHeight: `${window.innerHeight - 280}px` }}>
                 {this.obDatatable()}
               </tbody>
             </table>
           </div>
         </div>
       </React.Fragment>

        );
    }
}
const mapStateToProps = state  => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps) (Misc);